<div class="card">
    <div class="card-header">
        <h2>{{ 'shared.heading.commission-group' | translate }}</h2>
    </div>

    <table class="table card-table table-stripped table-bordered" *ngIf="items.length">
        <!-- Head -->
        <thead>
            <tr>
                <th>
                    {{ 'shared.table.group' | translate }}
                </th>
                <th class="centered">
                    Awin
                </th>
                <th class="centered">
                    {{ 'shared.table.reward' | translate }}
                </th>
            </tr>
        </thead>
        <!-- Body -->
        <tbody>
            <tr *ngFor="let item of items">
                <th class="elipsis" [title]="item.name">
                    {{ item.name }}
                </th>
                <td class="centered">
                    <span *ngIf="item.type === 'percentage'">
                        {{ item.awin_percentage | localizedNumber: '1.2-2' }}%
                    </span>

                    <span *ngIf="item.type === 'fix'">
                        {{ item.awin_amount | localizedNumber: '1.2-2' }}€
                    </span>
                </td>

                <td class="centered">
                    <span *ngIf="item.type === 'percentage'">
                        {{ item.reward_percentage | localizedNumber: '1.2-2' }}%
                    </span>

                    <span *ngIf="item.type === 'fix'">
                        {{ item.reward_amount | localizedNumber: '1.2-2' }}€
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
